module.exports = __webpack_public_path__ + "img/section1Bg.23d4d841.webp";